import { Typography } from 'antd';
import styled from 'styled-components';

export const StyledTitle = styled(Typography.Title)`
  margin-top: 0;
`;

export const StyledFormWrapper = styled.div`
  .ant-form-item-label > label {
    font-weight: 600;
  }
`;
